<template>
  <aside :class="['app-sidebar', {'active': isActive}]" id="sidebar">
    <div class="sidebar-header">
      <span class="sidebar-brand" href="#">
        <template v-if="logoUrl">
          <img class="img-responsive" :src="logoUrl" />
        </template>
        <template v-else>
          {{ pageTitle }}
        </template>
      </span>
      <button type="button" class="sidebar-toggle" v-on:click="close">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <ul class="sidebar-nav">
        <selem
          v-for="(item, index) in menu"
          :title="item.title"
          :icon="item.icon"
          :icon-prefix="item.iconPrefix"
          :children="item.children"
          :url="item.url"
          :index="item.index"
          :id="getItemId(item)"
          :active="isItemActive(item, index)"
          :indicator="item.indicator"
          ref="items"
          v-on:click="handleClick(item, index)"
        ></selem>
      </ul>
    </div>
    <!--
    <div class="sidebar-footer">
      <ul class="menu">
        <li>
          <a href="/" class="dropdown-toggle" data-toggle="dropdown">
            <i class="fa fa-cogs" aria-hidden="true"></i>
          </a>
        </li>
        <li><a href="#"><span class="flag-icon flag-icon-th flag-icon-squared"></span></a></li>
      </ul>
    </div>
    -->
  </aside>
</template>
<script>
import SidebarElem from './SidebarElem.vue';

export default {
  components: {
    'selem': SidebarElem
  },
  props: {
    logoUrl: {
      type: String
    },
    pageTitle: {
      type: String
    },
    currentView: {
      type: String
    },
    currentViewParam: {
      type: [String, Number],
    },
    isActive: {
      type: Boolean,
      default: false
    },
    menu: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  computed: {
    activeElem() {
      return this.menu.find(item => item.url === this.currentView && item.index === this.currentViewParam)
          || this.menu.find(item => item.url === this.currentView && !item.index)
          || this.menu.find(item => Array.isArray(item.subViews) && item.subViews.indexOf(this.currentView) > -1)
          || null;
    }
  },
  mounted () {
    setTimeout(() => {
      this.updateTitle();
    }, 1);
  },
  methods: {
    close() {
      this.$parent.sidebarOpen = false;
    },
    handleClick(item, index) {
      window.location.hash = `#${item.slug || item.id || index}`;
      this.$forceUpdate();

      if (typeof item.onClick === 'function') {
        item.onClick.call(this);
      } else {
        setTimeout(() => {
          this.updateTitle();
        }, 1)
      }
      this.$parent.sidebarOpen = false;
    },
    getItemId(item) {
      return item.hasOwnProperty('id') ? item.id : item.url;
    },
    isItemActive(item) {
      if (window.location.hash) {
        const idx = window.location.hash.substr(1);
        const active = this.menu.find(({slug, id}) => slug === idx || id === idx) || this.menu[idx];
        return active === item;
      }

      return item === this.activeElem;
    },
    resetMessagesCounter() {
      (this.$refs.items || []).forEach(x => x.refreshIndicator('message'));
    },
    updateTitle() {
      this.menu.forEach((item) => {
        if (this.isItemActive(item)) {
          this.$parent.viewTitle = typeof item.title === 'string' ? item.title : this.$t(item.title);
        }
      })
    }
  }
}
</script>
